<template>
    <div style="background-color: white; padding: 15px;">
        <div v-if="loading" class="d-flex justify-content-center">
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        </div>
        <div v-else>
            <p style="font-weight:bold;">
                {{ mode == "create" ? "Add New" : "Update" }} Template
            </p>
            <div class="d-flex align-items-center mb-3">
                <div class="filter-grid">
                    <el-select
                        v-model="template.paymentStatus"
                        multiple
                        collapse-tags
                    >
                        <el-option label="All" :value="null" />
                        <el-option label="Fully Paid" value="full-paid" />
                        <el-option label="Some Payments Made" value="some-paid" />
                        <el-option label="Partial Payment" value="partial-paid" />
                        <el-option label="Not Paid" value="not-paid" />
                    </el-select>
                    <el-select
                        v-model="template.type"
                        multiple
                        collapse-tags
                    >
                        <el-option label="All" :value="null" />
                        <el-option
                            v-for="t in types"
                            :label="t.name"
                            :value="t._id"
                        />
                    </el-select>
                    <el-select
                        v-model="template.activity"
                        multiple
                        collapse-tags
                    >
                        <el-option label="All" :value="null" />
                        <el-option
                            v-for="activity in activities"
                            :label="activity.name"
                            :value="activity._id"
                        />
                    </el-select>

                    <div style="display: flex; gap:5px; flex-direction: column;" v-for="(f, i) in fieldsForFilter" :key="f._id">
                        <p style="font-size: smaller; margin: 0;" for="">{{ f.name }}</p>
                        <el-select
                            v-model="fieldValuesAddedToFilter[i]"
                            multiple
                            collapse-tags
                            class="m-0 p-0"
                            @change="handleFieldFilterChange(f, i)"
                            >
                            <el-option label="All" :value="null" />
                            <el-option
                                v-for="val in f.values.split('\n')"
                                v-if="val"
                                :label="val"
                                :value="val"
                                @click="handleFieldFilterChange(0,1)"
                            />
                        </el-select>
                    </div>
                </div>
                <div class="ml-4">
                    <el-checkbox v-model="template.checkedIn"
                        >Checked In</el-checkbox
                    ><br />
                    <el-checkbox v-model="template.primaryRegistrantsOnly"
                        >Primary Registrants only</el-checkbox
                    ><br />
                </div>
            </div>
            <div class="form-group">
                <label>Name</label>
                <el-input v-model="template.name" placeholder="name" />
            </div>
            <div class="form-group">
                <label>Content</label>
                <Editor v-model="template.content" />
                <!-- <quill-editor v-model="template.content"/> -->
            </div>
            <div class="d-flex justify-content-left">
                <ul>
                    <li>
                        Use ${confirmation_number} to display the registration
                        Confirmation Number
                    </li>
                    <li>
                        Use ${total_amt} to display the registration total
                        amount
                    </li>
                    <li>
                        Use ${due_amt} to display the due amount on the
                        registration
                    </li>
                    <li>Use ${registrant_id} to get the registrant Id</li>
                    <li>Use ${registrant_count} to get the registrant count</li>
                    <li>Use ${registrant_type} to get the registrant type</li>
                    <li>
                        Use ${allregistrants.fieldname} to get all info for all
                        registrants
                    </li>
                    <li>Use ${paid_amt} to know the amount paid</li>
                    <li>
                        Use ${registration_created_date} to get registration
                        created date
                    </li>
                </ul>
            </div>

            <div class="d-flex justify-content-end">
                <button @click="handleClick" class="btn-primary btn ">
                    {{ mode == "create" ? "Create" : "Update" }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import http from "../../http";
import Editor from "../../components/Editor.vue";

export default {
    props: {
        templateId: String,
        fieldsForFilter:{
            type: Array,
            default:[]
        }
    },
    components: {
        Editor
    },
    computed: {
        ...mapState(["user", "types", "event", "activities"])
    },
    data() {
        return {
            template: {
                paymentStatus: [],
                type: [],
                activity: [],
                checkedIn: false,
                primaryRegistrantsOnly: false,
                name: "",
                content: "",
                event: null,
                fieldMatches: {}
            },
            mode: "create",
            loading: false,
            fieldValuesAddedToFilter:[],
            fieldMatches: {}
        };
    },
    methods: {
        async handleClick() {
            if (!this.template.name) {
                this.$notify({ type: "danger", message: "name is required" });
                return;
            }
            if (!this.template.content) {
                this.$notify({
                    type: "danger",
                    message: "content is required"
                });
                return;
            }

            if (this.mode == "create") {
                try {
                    const res = await http.post(
                        "/api/templates",
                        this.template
                    );
                    if (res.data.message) {
                        this.$notify(res.data.message);
                    }
                    this.$store.dispatch("getAll", {
                        path: "templates",
                        query: `event=${this.$route.params.eventId}` 
                    });
                    this.$emit("close");
                } catch (error) {
                    this.$store.dispatch("handleErrors", error);
                }
            } else if (this.mode == "edit") {
                try {
                    const res = await http.patch(
                        `/api/templates/${this.template._id}`,
                        this.template
                    );
                    if (res.data.message) {
                        this.$notify(res.data.message);
                    }
                    this.$store.dispatch("getAll", {
                        path: "templates",
                        query: `event=${this.$route.params.eventId}` 
                    });
                    this.$emit("close");
                } catch (error) {
                    if (error.response.data.message) {
                        this.$store.dispatch("handleErrors", error);
                    }
                }
            }
        },
        handleFieldFilterChange(field, i) {
            this.fieldMatches[field._id] = this.fieldValuesAddedToFilter[i];
            Object.keys(this.fieldMatches).forEach(key => {
                if(this.fieldMatches[key].length == 0){
                    delete this.fieldMatches[key];
                }
            })

            this.template.fieldMatches = this.fieldMatches
        },
    },
    async mounted() {
        if (this.templateId) {
            this.loading = true;
            this.mode = "edit";
            this.template = (await http.get(
                `/api/templates/${this.templateId}`
            )).data.template;
            
            this.fieldsForFilter.forEach((f, i) =>{
                let val = this.template.fieldMatches ? this.template.fieldMatches[f._id] : null
                this.fieldValuesAddedToFilter[i] = val ? val : []
            })
            this.fieldMatches = this.template.fieldMatches ? this.template.fieldMatches : {}
        }
        this.template.event = this.$route.params.eventId;

        try {
            await Promise.all([
                this.$store.dispatch("getAll", {
                    path: "types",
                    params: { filters: { eventId: this.$route.params.eventId } }
                }),
                this.$store.dispatch("getAll", {
                    path: "activities",
                    params: { filters: { eventId: this.$route.params.eventId } }
                })
            ]);
        } catch (e) {
            console.log(e);
            console.log("error getting additional data");
        }
        this.loading = false;
    }
};
</script>
